import PropTypes from 'prop-types'

import { cn } from '@/utils/helpers'

function Table({ className, ...props }) {
  return (
    <div data-slot="table-container" className="relative w-full overflow-x-auto">
      <table
        data-slot="table"
        className={cn(
          'flex w-max min-w-full caption-bottom flex-col flex-nowrap text-sm',
          className,
        )}
        {...props}
      />
    </div>
  )
}

Table.propTypes = {
  className: PropTypes.string,
}

function TableHeader({ className, ...props }) {
  return (
    <thead
      data-slot="table-header"
      className={cn('flex w-max min-w-full [&_tr]:border-b', className)}
      {...props}
    />
  )
}

TableHeader.propTypes = {
  className: PropTypes.string,
}

function TableBody({ className, ...props }) {
  return (
    <tbody
      data-slot="table-body"
      className={cn('flex w-max min-w-full flex-col [&_tr:last-child]:border-0', className)}
      {...props}
    />
  )
}

TableBody.propTypes = {
  className: PropTypes.string,
}

function TableFooter({ className, ...props }) {
  return (
    <tfoot
      data-slot="table-footer"
      className={cn('bg-muted/50 border-t font-medium [&>tr]:last:border-b-0', className)}
      {...props}
    />
  )
}

TableFooter.propTypes = {
  className: PropTypes.string,
}

function TableRow({ className, ...props }) {
  return (
    <tr
      data-slot="table-row"
      className={cn(
        'data-[state=selected]:bg-muted even:bg-muted flex w-max min-w-full flex-row border-b transition-colors',
        className,
      )}
      {...props}
    />
  )
}

TableRow.propTypes = {
  className: PropTypes.string,
}

function TableHead({ className, ...props }) {
  return (
    <th
      data-slot="table-head"
      className={cn(
        'text-foreground flex h-10 items-center text-left align-middle font-medium whitespace-nowrap [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px]',
        className,
      )}
      {...props}
    />
  )
}

TableHead.propTypes = {
  className: PropTypes.string,
}

function TableCell({ className, ...props }) {
  return (
    <td
      data-slot="table-cell"
      className={cn(
        'truncate p-2 align-middle whitespace-nowrap [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px]',
        'flex items-center',
        className,
      )}
      {...props}
    />
  )
}

TableCell.propTypes = {
  className: PropTypes.string,
}

function TableCaption({ className, ...props }) {
  return (
    <caption
      data-slot="table-caption"
      className={cn('text-muted-foreground mt-4 text-sm', className)}
      {...props}
    />
  )
}

TableCaption.propTypes = {
  className: PropTypes.string,
}

export { Table, TableHeader, TableBody, TableFooter, TableHead, TableRow, TableCell, TableCaption }
